import { gql } from 'urql';

const GetDiscoverMoreEligibleProducts = gql`
  query GetDiscoverMoreEligibleProducts($input: DiscoverMorePageInput!) {
    discoverMorePage(input: $input) {
      ... on DiscoverMorePageTile {
        id
        tileType
        status
        title
        displayAnalytics {
          name
          properties {
            key
            value
          }
        }
        topSection {
          id
          tileType
          status
          productType
          title
          description
          onClickAnalytics {
            name
            properties {
              key
              value
            }
          }
        }
        middleSection {
          id
          tileType
          status
          productType
          title
          description
          onClickAnalytics {
            name
            properties {
              key
              value
            }
          }
        }
      }
      ... on DiscoverMorePageError {
        message
        code
      }
    }
  }
`;

export default GetDiscoverMoreEligibleProducts;
